import { ProductSerialize } from './product/Product'
import type Sliders from '~/type/Sliders'

export default function (el: any): Sliders {
  return {
    title: el.GROUP_NAME,
    list: el.ITEMS?.length ? el.ITEMS.map((item: any) => ProductSerialize(item)) : [],
  }
}
